var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon - WiFi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OS_Head",
    transform: "translate(-1226.000000, -36.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1236,51 L1234,49 C1235,48.5 1234.43357,48.5 1236,48.5 C1237.48929,48.5 1237,48.5 1238,49 L1236,51 Z M1236.00204,44.7009926 C1237.70612,44.7009926 1239.41837,45.4184277 1240.72245,46.8472351 L1240.12653,47.5 C1238.98776,46.2470147 1237.49592,45.624564 1236.00204,45.6225431 C1234.50612,45.624564 1233.01429,46.2470147 1231.87551,47.5 L1231.28163,46.8472351 C1232.58367,45.4184277 1234.29388,44.7009926 1236.00204,44.7009926 Z M1236,40.576246 C1238.66939,40.576246 1241.33878,41.6958489 1243.37551,43.9330339 L1242.78163,44.5857988 C1240.90612,42.5264569 1238.45714,41.5018383 1236,41.4998174 C1233.5449,41.4998174 1231.09388,42.5264569 1229.22041,44.5837779 L1228.62653,43.931013 C1230.66327,41.6958489 1233.33265,40.576246 1236,40.576246 Z M1236,36.500002 C1239.61837,36.4979811 1243.23673,38.01571 1246,41.0471259 L1245.40612,41.6998908 C1242.80816,38.844297 1239.40816,37.4215525 1236,37.4195315 C1232.59592,37.4215525 1229.19184,38.846318 1226.59388,41.7019118 L1226,41.0491469 C1228.76122,38.0177309 1232.38163,36.500002 1236,36.500002 Z",
    id: "Icon---WiFi",
    style: {
      mixBlendMode: "hard-light"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.e44135d44e3f44387a27d17c49dbf66e.svg";
export { ForwardRef as ReactComponent };